 
import React from "react";
import { StandadCard } from "../../../../../../components/Cards";
import { Divider, Tab, Tabs } from "@mui/material";
import {
  AccountCircle,
  AdminPanelSettings,
  StickyNote2,
} from "@mui/icons-material";
import { a11yProps } from "../../../../../../components/Tabs/utils";
import { TabPanel } from "../../../../../../components/Tabs/TabPanel";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import {
  clearAutomobileVehicleState,
  fetchAutomobileVehicleAsync,
} from "../../../../../../redux/automobileVehicle/automobileVehicleActions";
import { AutomobileVehicleInformation } from "./AutomobileVehicleInformation/AutomobileVehicleInformation";
import { AutomobileAdditionalInformation } from "./AutomobileAdditional/AutomobileAdditional";
import { AutomobileVehicleInterestedList } from "./AutomobileInterested/AutomobileInterestedList";
import {
  IAutomobileAdditionalInformation,
  IAutomobileVehicleInformation,
} from "../../../../../../redux/automobileVehicle/automobileVehicle.types";

interface IAutomobileVehcileProps {
  customerId?: number;
  customerPolicyId?: number;
  vehicleNumber?: number;
  readOnly?: boolean;
  fromRightPanel?: boolean;
  staticStatusValue?: string;
  created_from?: string;
  onVehicleSaveSuccess?: (data: IAutomobileVehicleInformation) => void;
  onAdditionalInfoSaveSucces?: (data: IAutomobileAdditionalInformation) => void;
  disableApiCalls?: boolean;
}

export const AutomobileVehicle: React.FC<IAutomobileVehcileProps> = ({
  customerId,
  customerPolicyId,
  vehicleNumber,
  onVehicleSaveSuccess,
  fromRightPanel,
  onAdditionalInfoSaveSucces,
  readOnly
}) => {
  const [tab, setTab] = React.useState(0);

  const savedVehicleNumber = useSelector(
    (storeState: IStoreState) => storeState.automobile.vehicle.vehicleNumber
  );

  const dispatch = useDispatchWrapper();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const changeStep = (value: number) => {
    setTab(value);
  };

  React.useEffect(() => {
    if (customerPolicyId && vehicleNumber) {
      dispatch(fetchAutomobileVehicleAsync(customerPolicyId, vehicleNumber));
    }
    return () => {
      dispatch(clearAutomobileVehicleState());
    };
  }, [customerPolicyId]);

  return (
    <>
      <StandadCard renderWithoutCard={fromRightPanel} sx={{ mt: 2 }}>
        <Tabs
          value={tab}
          variant="fullWidth"
          scrollButtons="auto"
          onChange={handleChange}
        >
          <Tab
            icon={<AccountCircle />}
            iconPosition="start"
            label="Vehicle Information"
            {...a11yProps(0)}
          />
          <Tab
            sx={{ minHeight: "50px" }}
            icon={<AdminPanelSettings />}
            iconPosition="start"
            label="Additional Information"
            disabled={!savedVehicleNumber}
            {...a11yProps(1)}
          />
          <Tab
            sx={{ minHeight: "50px" }}
            icon={<StickyNote2 />}
            iconPosition="start"
            label="Interested Parties"
            disabled={!savedVehicleNumber}
            {...a11yProps(2)}
          />
        </Tabs>
        <Divider />
        <TabPanel value={tab} index={0}>
          <AutomobileVehicleInformation
            customerPolicyId={customerPolicyId}
            customerId={customerId}
            vehicleNumber={vehicleNumber}
            changeStep={changeStep}
            readOnly={readOnly}
            onSaveSuccess={onVehicleSaveSuccess}
          />
        </TabPanel>

        {customerPolicyId && customerId && savedVehicleNumber && (
          <>
            <TabPanel value={tab} index={1}>
              <AutomobileAdditionalInformation
                customerId={customerId}
                customerPolicyId={customerPolicyId}
                vehcileNumber={savedVehicleNumber}
                changeStep={changeStep}
                onSaveSuccess={onAdditionalInfoSaveSucces}
                readOnly={readOnly}
              />
            </TabPanel>

            <TabPanel value={tab} index={2}>
              <AutomobileVehicleInterestedList
                customerId={customerId}
                customerPolicyId={customerPolicyId}
                vehicleNumber={savedVehicleNumber}
                readonly={readOnly}
              />
            </TabPanel>
          </>
        )}
      </StandadCard>
    </>
  );
};
